<template>
  <div class="_wrap">
    <div class="carousel_wrap page-item">
      <el-carousel   arrow="always" class="hidden-xs-only carousel_banner">
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <img :src="item.src" alt="" class="img_item1" />
          <!-- <div class="tips_font">
            <h1>{{ item.line1 }}</h1>
            <h1>{{ item.line2 }}</h1>
          </div> -->
          <div class="circle-arrow" @click="scrollToScreen()"></div>
        </el-carousel-item>
      </el-carousel>
      <el-carousel height="50vw" arrow="always" class="hidden-sm-and-up">
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <img :src="item.src" alt="" class="img_item" />
          <div class="tips_font">
            <h1>{{ item.line1 }}</h1>
            <h1>{{ item.line2 }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="profile_content page-item" ref="screen4">
        <div class="profile_wrap">
          <div style="width:100%">
            <el-row  type="flex" align="middle" style="width:100%" class="hidden-xs-only">
                <el-col :md="12" :sm="24">
                    <div class="grid-content bg-purple left" style="height:100%;">
                        <el-row :gutter="80">
                            <el-col  
                                v-for="(item, index) in dataList"
                                :key="index" 
                                :md="12" 
                                :sm="12"
                                :xs="24">
                                <div class="company_label wow zoomInLeft">{{item}}</div>
                            </el-col>
                        </el-row> 
                    </div>
                </el-col>
                <el-col :md="12" :sm="24">
                    <div class="right">
                        <div class="swiper-container">
                          <!-- <img @click="handleInfo(item.ID)" :src="companyurl" class="swiper_img wow zoomInRight" alt="" /> -->
                            <swiper :options="swiperOption" ref="mySwiper1" v-if="companySwiper.length > 0">
                                <swiper-slide v-for="(item, index) in companySwiper" :key="index">
                                    <img @click="handleInfo(item.ID)" :src="item.url"  class="swiper_img" alt="" />
                                </swiper-slide>
                                <div class="swiper-pagination" slot="pagination"></div>
                            </swiper>
                        </div>    
                    </div>
                </el-col>
            </el-row>  
            <el-row class="hidden-xs-only">
              <el-col :md="12" :sm="24">
                    <div class="more" @click="handleNavigate">了解更多</div>
                </el-col>
            </el-row>
            <el-row class="hidden-sm-and-up">
                <el-col :md="12" :sm="24">
                    <div class="grid-content bg-purple left" style="height:100%">
                        <el-row :gutter="40">
                            <el-col  
                                v-for="(item, index) in dataList"
                                :key="index" 
                                :span="12">
                                <div class="company_label wow zoomInRight">{{item}}</div>
                            </el-col>
                        </el-row> 
                    </div>
                    <div class="more" @click="handleNavigate">了解更多</div>
                </el-col>
                <el-col :span="24" type="flex" align="middle">
                    <div class="right">
                        <div class="swiper-container">
                          <!-- <img @click="handleInfo(item.ID)" :src="companyurl" class="swiper_img wow zoomInRight" alt="" /> -->
                            <swiper :options="swiperOption" ref="mySwiper1" v-if="companySwiper.length > 0">
                                <swiper-slide v-for="(item, index) in companySwiper" :key="index">
                                    <img @click="handleInfo(item.ID)" :src="item.url" class="swiper_img" alt="" />
                                </swiper-slide>
                                <div class="swiper-pagination" slot="pagination"></div>
                            </swiper>
                        </div> 
                    </div>
                </el-col>
            </el-row>
          </div>    
        </div>
    </div>  
    <div class="enterprise_culture page-item">
        <div class="culture_content">
            <div class="content_title wow zoomIn">企业文化</div>
            <el-row >
                <el-col  
                    v-for="(item, index) in dataList1"
                    :key="index" 
                    :md="8" 
                    :sm="12"
                    :xs="12">
                    <div class="company_label wow zoomInRight">
                        <div class="line">{{item.title}}</div>
                        <div class="line2">{{item.title1}}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div> 
  </div>
  

</template>

<script>
import { WOW } from 'wowjs'
export default {
  data() {
    return {
      imgList: [
        {
          src: require('@/assets/img/about/aboutbg4.jpg'),
        },
        {
          src: require('@/assets/img/about/aboutbg8.jpg'),
        }
      ],
      src: require('@/assets/img/companyInfo.png'),
      companySwiper:[
          {
              url: require('@/assets/img/demo/bg5.jpg')
          },
          {
              url: require('@/assets/img/demo/bg3.jpg')
          }
      ],
      companyurl:require('@/assets/img/demo/bg3.jpg'),
      swiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 500,
        autoHeight: false,
        spaceBetween: 0, // 设置为0，避免间距
        effect: 'fade',
        fadeEffect: {
          crossFade: true // 交叉淡入淡出，确保只有一张显示
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true,
        },  
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // 添加预加载控制
        preloadImages: false,
        lazy: {
          loadPrevNext: false, // 不预加载相邻图片
          loadPrevNextAmount: 0 // 不加载相邻图片
        }
      },
      dataList: ['系统运营','软件开发','网页设计','培训服务','采购咨询','特产自营'],
      dataList1: [
        {
          title:'客户',
          title1:'第一',
        },
        {
          title:'诚信',
          title1:'服务',
        },
        {
          title:'团队',
          title1:'协作',
        },
        {
          title:'精准',
          title1:'高效',
        },
        {
          title:'拥抱',
          title1:'变化',
        },
        {
          title:'智创',
          title1:'未来',
        }],
        // ========== 2. 分页逻辑核心变量（新增） ==========
      currentPage: 0, // 当前页面索引（封面=0，section1=1，section2=2，BusinessScope=3）
      TIME_LIMIT: 1000, // 防连续滚动时间限制（毫秒）
      lastScrollTime: 0, // 上次滚动时间戳
      lastPageTop: 0, // 最后一页顶部位置
      pages: [], // 所有分页元素集合（.page-item）
      lastPageIndex: 0, // 最后一页索引
      lastPage: null // 最后一页DOM元素
    }
  },
  mounted() {
    new WOW().init()
    // ========== 3. 分页逻辑初始化（新增） ==========
    this.initPagination()
  },
  beforeUnmount() {
    // ========== 4. 移除事件监听（防止内存泄漏，新增） ==========
    this.removePaginationEvents()
  },
  methods: {
    // scrollToScreen(){
    //   console.log(this.$refs['screen4'])
    //   this.$refs['screen4'].scrollIntoView({
    //       behavior: 'smooth'
    //   });
    // },
    
    handleNavigate(){
      this.$router.push('/production/contact').catch((v) => {})
    },

    // ========== 5. 原有方法：适配分页逻辑（修改） ==========
    scrollToScreen() {
      const targetPageIndex = 1 // 目标页：第一个section（对应模板中.page-item索引1）
      this.currentPage = targetPageIndex
      this.lastScrollTime = Date.now() // 更新滚动时间，避免与wheel事件冲突
      this.pages[targetPageIndex].scrollIntoView({ behavior: 'smooth' })
    },

    // ========== 6. 分页逻辑工具函数（新增） ==========
    // 计算元素在文档中的绝对顶部位置（不是视口内位置）
    getElementPosition(element) {
      return element.getBoundingClientRect().top + window.scrollY
    },

    // 判断是否在最后一页的顶部区域（允许10px误差）
    isLastPageAtTop() {
      return window.scrollY >= this.lastPageTop - 10 && window.scrollY <= this.lastPageTop + 10
    },

    // 更新最后一页的顶部位置（窗口 resize 时需重新计算）
    updateLastPagePosition() {
      this.lastPageTop = this.getElementPosition(this.lastPage)
    },

    // ========== 7. 分页逻辑：初始化（新增） ==========
    initPagination() {
      // 1. 获取所有分页元素（.page-item）
      this.pages = document.querySelectorAll('.page-item')
      // 2. 初始化最后一页信息
      this.lastPageIndex = this.pages.length - 1
      this.lastPage = this.pages[this.lastPageIndex]
      // 3. 初始化最后一页顶部位置
      this.updateLastPagePosition()
      // 4. 添加事件监听
      this.addPaginationEvents()
    },

    // ========== 8. 分页逻辑：添加事件监听（新增） ==========
    addPaginationEvents() {
      // 窗口 resize 时更新最后一页位置
      window.addEventListener('resize', this.updateLastPagePosition)
      // 鼠标滚轮事件（核心：控制页面切换）
      window.addEventListener('wheel', this.handleWheel, { passive: false })
      // 滚动事件（辅助：更新当前页面索引，防止手动滚动后索引错乱）
      window.addEventListener('scroll', this.handleScrollUpdateCurrentPage)
    },

    // ========== 9. 分页逻辑：移除事件监听（新增） ==========
    removePaginationEvents() {
      window.removeEventListener('resize', this.updateLastPagePosition)
      window.removeEventListener('wheel', this.handleWheel, { passive: false })
      window.removeEventListener('scroll', this.handleScrollUpdateCurrentPage)
    },

    // ========== 10. 分页逻辑：滚轮事件处理（核心，新增） ==========
    handleWheel(e) {
      const now = Date.now()

      // 情况1：当前在最后一页
      if (this.currentPage === this.lastPageIndex) {
        // 判断最后一页是否有可滚动内容（内容高度 > 视口高度）
        const lastPageHasScrollableContent = this.lastPage.offsetHeight > window.innerHeight

        // 向下滚动：允许正常浏览最后一页内容
        if (e.deltaY > 0) {
          // 不在最后一页顶部，或最后一页有滚动内容 → 允许正常滚动
          if (!this.isLastPageAtTop() || lastPageHasScrollableContent) {
            return // 不阻止默认行为
          }
        }
        // 向上滚动：回到上一页（需满足“不在时间限制内”+“在最后一页顶部”）
        else {
          if (this.isLastPageAtTop()) {
            // 防连续滚动：1秒内不重复触发
            if (now - this.lastScrollTime < this.TIME_LIMIT) {
              e.preventDefault()
              return
            }
            // 切换到上一页
            this.lastScrollTime = now
            this.currentPage = this.lastPageIndex - 1
            this.pages[this.currentPage].scrollIntoView({ behavior: 'smooth' })
            e.preventDefault()
          } else {
            return // 不在顶部 → 允许正常向上滚动
          }
        }
      }
      // 情况2：当前在非最后一页（封面/section1/section2）
      else {
        // 防连续滚动：1秒内不重复触发
        if (now - this.lastScrollTime < this.TIME_LIMIT) {
          e.preventDefault()
          return
        }

        this.lastScrollTime = now
        // 判断滚动方向，更新当前页面索引
        if (e.deltaY > 0) {
          // 向下滚动：前往下一页（不超过最后一页）
          if (this.currentPage < this.lastPageIndex) {
            this.currentPage++
          }
        } else {
          // 向上滚动：前往上一页（不小于0）
          if (this.currentPage > 0) {
            this.currentPage--
          }
        }
        // 滚动到目标页面
        this.pages[this.currentPage].scrollIntoView({ behavior: 'smooth' })
        e.preventDefault()
      }
    },

    // ========== 11. 分页逻辑：滚动时更新当前页面索引（新增） ==========
    handleScrollUpdateCurrentPage() {
      // 判断点：视口顶部往下1/3处（避免页面边缘触发误判）
      const currentScrollPos = window.scrollY + window.innerHeight / 3

      this.pages.forEach((page, index) => {
        const pageTop = this.getElementPosition(page)
        const pageBottom = pageTop + page.offsetHeight

        // 最后一页：只要滚动到顶部附近（-100px）就视为当前页
        if (index === this.lastPageIndex) {
          if (currentScrollPos >= pageTop - 100) {
            this.currentPage = index
          }
        }
        // 其他页：判断点在页面范围内 → 视为当前页
        else {
          if (currentScrollPos >= pageTop && currentScrollPos < pageBottom) {
            this.currentPage = index
          }
        }
      })
    }
  },
  watch: {
    $route() {
      this.optionActive = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    }
  }    
}
</script>

<style lang="scss">
/* 在全局样式或非scoped的style标签中 */
.carousel_wrap .el-carousel__arrow--left {
  left: 120px !important;
}

.carousel_wrap .el-carousel__arrow--right {
  right: 120px !important;
}

.profile_content{
  padding-top:60px ;
  box-sizing: border-box;
  background-image: url('../../assets/img/business/contentbg.png');
  background-position: 0 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .profile_wrap {
          // width: 70%;
          margin: 0 auto;
          display: flex;
          align-items: center;
          height: calc(100vh);
          @media screen and (max-width: 768px) {
              height: auto !important;
          }
          .more{
            width: 139px;
            height: 35px;
            margin: 0 auto;
            background: #d5d5d5;
            font-size: 21px;
            font-family: Adobe Heiti Std, Adobe Heiti Std-R;
            font-weight: normal;
            text-align: center;
            color: #2c2c2c;
            margin-bottom: 10px;
          }
          .left{
              height: 100% !important;
              padding: 20px 0;
              box-sizing: border-box;
              margin-left: 20%;
              margin-right: 10%;
              @media screen and (max-width: 768px) {
                  margin: 0 20px !important;
                  overflow: hidden;
              }
              
              .info{
                  text-indent: 2em;
                  word-spacing: 2px;
              }
              .marginB22{
                  margin-bottom: 22px;
              }
              .company_label{
                  padding: 20px  30px;
                  box-sizing: border-box;
                  margin:20px 0;
                  text-align: center;
                  background: rgb(81, 80, 80,0.1);
                  font-size: 32px;
                  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
                  font-weight: normal;
                  color: #2c2c2c;
                  @media screen and (max-width: 1200px) {
                      height: auto;
                      font-size: 24px;
                  }
                  @media screen and (max-width: 768px) {
                      font-size:18px;
                      padding: 5px; 
                      margin-bottom:20px ;
                  }
                  // line-height: 12px;
                  // letter-spacing: 3.67px;
              }
              .company_name{
                  font-size:32px; 
                  font-weight:600;
                  @media screen and (max-width: 768px) {
                      font-size:22px; 
                  }
              }
              .label{
                  background: #A81F27;
                  color: #fff;
                  text-align: center;
              }
          }
          .right {
            position: relative;
            margin: 0 auto;
            height: 348px;
            display: flex;
            overflow: hidden;
            justify-content: center;
            align-items: center;
            @media screen and (max-width: 768px) {
              height:  368px;
            }
            
            .swiper-container {
              width: 100%;
              height: 100%;
              overflow: hidden;
            }
            
            // .swiper-slide {
            //   display: flex;
            //   justify-content: center;
            //   align-items: center;
            //   height: 100%;
            //   width: 100%;
            //   position: relative; // 添加
            // }
            .swiper-slide {
              display: flex;
              justify-content: center;
              align-items: center;
              opacity: 0 !important;
              transition: opacity 0.5s ease !important;
              position: absolute !important;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            //   @media screen and (max-width: 768px) {
            //     left: 41px;
            // }
          }

          .swiper-slide-active,
          .swiper-slide-duplicate-active {
            opacity: 1 !important;

            position: relative !important;
            z-index: 10;
            @media screen and (max-width: 768px) {
              position: absolute !important;
              z-index: 1;
            }
          }
  
          .swiper-slide img {
            position: absolute; // 改为绝对定位
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            max-width: 100%;
            object-fit: contain; // 关键：控制图片填充方式
            display: block;
            transition:  5s linear;
            transform: scale(1.2);
            
            @media screen and (max-width: 768px) {
              margin: 0 auto;
            }
          }
          .swiper-slide-active img,
          .swiper-slide-duplicate-active img {
            transform: scale(1, 1);
          }
        }
      }
    }  
    .enterprise_culture{
    height: calc(100vh);
    background-image: url('../../assets/img/business/contentbg.png');
    background-position: 0 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // overflow: hidden;
    @media screen and (max-width: 1200px) {
        height:auto;
    }
    @media screen and (max-width: 768px) {
        height:auto;
    }
    .culture_content{
        width: 80%;
        margin: 0 auto;
        .content_title{
            padding: 100px 0 120px;  
            box-sizing: border-box;
            font-size: 48px;
            font-family: Adobe Heiti Std, Adobe Heiti Std-R;
            font-weight: bold;
            text-align: left;
            color: #2c2c2c;
            letter-spacing: 13.33px;
            text-align: center ;
            @media screen and (max-width: 1200px) {
                font-size: 30px;
            }
            @media screen and (max-width: 768px) {
                font-size: 22px;
                padding: 10px 0 20px;
            }
        }
        .company_label{
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 50px;
          box-sizing: border-box;
          margin-bottom:40px ;
          margin-left: 80px;
          text-align: center;
          background: rgb(81, 80, 80,0.1);
          font-size: 32px;
          font-family: Adobe Heiti Std, Adobe Heiti Std-R;
          font-weight: normal;
          color: #2c2c2c;
          @media screen and (max-width: 1200px) {
              font-size: 22px;
          }
          @media screen and (max-width: 768px) {
              padding: 10px;
              margin-bottom:20px;
              font-size: 18px;
              margin-left: 20px;
          }
          .line{
              // background: #813536;
              border-bottom: 4px solid #813536;
              @media screen and (max-width: 1200px) {
                border-bottom: 2px solid #813536;
              }
              @media screen and (max-width: 768px) {
                border-bottom: 1px solid #813536;
              }
          }
          .line2{
              // background: #813536;
              border-bottom: 4px solid rgba(81, 80, 80, -0.9);
              @media screen and (max-width: 1200px) {
                border-bottom: 2px solid rgba(81, 80, 80, -0.9);
              }
              @media screen and (max-width: 768px) {
                border-bottom: 1px solid rgba(81, 80, 80, -0.9);
              }
          }
        // line-height: 12px;
        // letter-spacing: 3.67px;
    }

    }
    
}      
</style>